var common={
	commonPopEl:$(".m-commonPop"),
	commonCallback:null,
	confirmPopEl:$(".m-commonPop"),
	sideEl:$(".m-side"),
	init:function(){
		var _this=this;
		this.commonPopEl.find(".confirmBtn").click(function(){
			_this.commonPopEl.hide();
			if(_this.commonCallback){
				_this.commonCallback();
			}
		})
		this.sideEl.find(".switchBtn").click(function(){
			if(_this.sideEl.hasClass("close")){
				_this.sideEl.removeClass("close");
			}else{
				_this.sideEl.addClass("close");
			}
			
		})
		$(".m-side-close").click(function(){
			_this.sideEl.removeClass("close");
		})
	},
	getQueryString:function(name){
		var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
	    var r = window.location.search.substr(1).match(reg);
	    if(r!=null)return  unescape(r[2]); return null;
	},
	showCommonPop:function(info){
		this.commonPopEl.find(".info").html(info);
		this.commonPopEl.show();
	},
	toDecimal:function(x) {  
        var f = parseFloat(x);  
        if (isNaN(f)) {  
            return false;  
        }  
        var f = Math.round(x*100)/100;  
        var s = f.toString();  
        var rs = s.indexOf('.');  
        if (rs < 0) {  
            rs = s.length;  
            s += '.';  
        }  
        while (s.length <= rs + 1) {  
            s += '0';  
        }  
        return s;  
    } 
}

Handlebars.registerHelper('date', function(timestamp) {
	var date=new Date(timestamp);
	return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
});

Handlebars.registerHelper('tuijianFormat', function(tuijian) {
	if(tuijian==0){
		return "暂无";
	}

	return common.toDecimal(tuijian)+"分";
});

Handlebars.registerHelper('tag', function(tagStr) {
	if(tagStr==""||tagStr==null){
		return "";
	}
	var tagObj=JSON.parse(tagStr);
	if(tagObj.type==0){
		return "PVP";
	}else{
		return "PVE";
	}
});

Handlebars.registerHelper('starFormat', function(tuijian) {
	if(tuijian==0){
		return "暂无";
	}
	tuijian=common.toDecimal(tuijian);
	var starCount=tuijian/2;
	var floor=Math.floor(starCount);
	var ceil=Math.round(starCount);
	var html='';
	for(var i=0;i<floor;i++){
		html+='<i class="star"></i>';
	}
	if(ceil>floor){
		html+='<i class="star half"></i>';
	}
	return html;
});

module.exports=common;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/common.js
// module id = 2
// module chunks = 0 1 2 3 4 5 6